import { CategoryBrowseOrganizerTags } from './CategoryBrowseOrganizerTags';

export default CategoryBrowseOrganizerTags;
